import { db, storage } from "../firebase/config";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { 
  collection, 
  doc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  onSnapshot
} from "firebase/firestore";

export function subscribeToAgendas(callback) {
  return onSnapshot(collection(db, "agendas"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    // Sort by date (descending)
    list.sort((a, b) => new Date(b.date) - new Date(a.date));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to agendas:", error);
    callback([], error);
  });
}

export async function addAgenda(data) {
  const agendaData = {
    ...data,
    dateAdded: new Date().toISOString(),
    attachments: data.attachments || [],
    items: data.items || []
  };
  const docRef = await addDoc(collection(db, "agendas"), agendaData);
  return docRef.id;
}

export async function updateAgenda(id, data) {
  const docRef = doc(db, "agendas", id);
  await updateDoc(docRef, data);
}

export async function deleteAgenda(id) {
  const docRef = doc(db, "agendas", id);
  await deleteDoc(docRef);
}

export async function uploadAgendaAttachment(agendaId, file) {
  const timestamp = Date.now();
  const filePath = `agendas/${agendaId}/${timestamp}_${file.name}`;
  const fileRef = ref(storage, filePath);
  
  await uploadBytes(fileRef, file);
  const downloadUrl = await getDownloadURL(fileRef);
  
  return {
    id: timestamp.toString(),
    name: file.name,
    url: downloadUrl,
    path: filePath
  };
}

export async function deleteAgendaAttachment(filePath) {
  const fileRef = ref(storage, filePath);
  await deleteObject(fileRef);
}
